module.exports = __webpack_public_path__ + "img/result_ceil_ust.e85c0b97.jpg";